'use client';

import { c as _c } from "react/compiler-runtime";
import { teams } from './_data';
import { teamCode } from './format';
export function ManagementMap(t0) {
  const $ = _c(12);
  const {
    onTeamSelect
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Math.min(...teams.map(_temp));
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const minPoints = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = Math.max(...teams.map(_temp2));
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const maxPoints = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = Math.max(...teams.map(_temp3));
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const maxChaos = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="mb-8 grid gap-6 lg:grid-cols-[0.8fr_1.2fr]"><div><h2 className="font-sans text-5xl font-semibold">Some managers worked the wire. Leyland was on a ski lift.</h2></div><p className="text-lg leading-8 font-semibold text-[#5f5364]">This is points for against roster chaos. Real Manhattan and fent folders changed constantly and scored. Leyverpool changed nothing and stayed alive. Hookah changed plenty without finding the same payoff, which is the uncomfortable corner of the chart.</p></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="absolute top-6 left-6 text-xs font-black text-[#6f6078] uppercase">More roster chaos ↑</div>;
    t6 = <div className="absolute right-6 bottom-6 text-xs font-black text-[#6f6078] uppercase">More points →</div>;
    t7 = <div className="absolute top-0 left-1/2 h-full w-px bg-[#d7c9b7]" />;
    t8 = <div className="absolute top-1/2 left-0 h-px w-full bg-[#d7c9b7]" />;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t5 = $[4];
    t6 = $[5];
    t7 = $[6];
    t8 = $[7];
  }
  let t9;
  if ($[8] !== onTeamSelect) {
    t9 = teams.flatMap(team_2 => {
      if (team_2.team === "AVERAGE") {
        return [];
      }
      const x = 7 + (team_2.pointsFor - minPoints) / (maxPoints - minPoints) * 86;
      const y = 87 - team_2.chaos / maxChaos * 74;
      const isSpecial = ["Real Manhattan", "fent folders", "Leyverpool", "Hookah Doncic", "Son Doku"].includes(team_2.team);
      return [<button key={team_2.team} type="button" onClick={() => onTeamSelect(team_2.team)} className={`absolute -translate-x-1/2 -translate-y-1/2 rounded-full border border-[#24122f] px-3 py-2 text-xs font-black transition hover:-translate-y-[55%] hover:shadow-[4px_4px_0_#24122f] ${isSpecial ? "bg-[#4ea97e] text-[#24122f]" : "bg-[#fffaf1] text-[#24122f]"}`} style={{
        left: `${x}%`,
        top: `${y}%`
      }} title={`${team_2.team}: ${team_2.pointsFor} pts, chaos ${team_2.chaos}`}>{teamCode(team_2.team)}</button>];
    });
    $[8] = onTeamSelect;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t9) {
    t10 = <section className="fantasy-reveal border-y border-[#24122f] bg-[#fffaf1]"><div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">{t4}<div className="relative h-[520px] overflow-hidden border border-[#24122f] bg-[#f0eadb] shadow-[8px_8px_0_#24122f]">{t5}{t6}{t7}{t8}{t9}</div></div></section>;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  return t10;
}
function _temp3(team_1) {
  return team_1.chaos;
}
function _temp2(team_0) {
  return team_0.pointsFor;
}
function _temp(team) {
  return team.pointsFor;
}